import React from 'react'
import {Spin} from "antd"
import TableHead from "./TableHead"
import TableBody from "./TableBody"

const TableBalance = (props) => {
    const {userTransaction, loading, error} = props

    return <Spin spinning={loading && userTransaction.length === 0} tip="Đang lấy dữ liệu...">
        <table className="table">
            <TableHead/>
            <TableBody loading={loading} error={error} userTransaction={userTransaction}/>
        </table>
    </Spin>
}

export default TableBalance
